import React from 'react';

const CustomerDetails = ({ details }) => (
  <div className="p-4 max-w-[700px]">
  {/* Row 1 */}
  <div className="flex flex-col sm:flex-row sm:justify-between mb-2">
    <p className="mb-2 sm:mb-0"><strong>Name:</strong> {details.name}</p>
    <p className="sm:mr-48"><strong>Phone:</strong> {details.phone}</p>
  </div>

  {/* Row 2 */}
  <div className="flex flex-col sm:flex-row sm:justify-between">
    <p className="flex-1 mb-2 sm:mb-0"><strong>Email:</strong> {details.email}</p>
    <p className="flex-1 mr-14"><strong>Address:</strong> {details.address}</p>
  </div>
</div>



);

export default CustomerDetails;
